import { FC, ReactNode } from 'react'
import { Text } from '../../text/textStyles'
import React from 'react'
import styled from 'styled-components'
import WarningIcon from '@tuhi/components/assets/icons/header/warning.svg'
import { contentColorStyle } from '../../buttons/button'

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`

const IconContainer = styled.div<{ $isError?: boolean }>`
    display: flex;
    align-items: center;
    ${(p) =>
        contentColorStyle(
            p.$isError
                ? p.theme.colors.primaryRed
                : p.theme.colors.primary.default
        )}
`

export interface InfoMessageProps {
    icon?: ReactNode
    message?: string
    isError?: boolean
}

export const InputInfoMessage: FC<InfoMessageProps> = ({
    icon,
    message,
    isError,
}) => {
    return (
        message && (
            <Container>
                {(icon || isError) && (
                    <IconContainer $isError={isError}>
                        {isError ? <WarningIcon /> : icon}
                    </IconContainer>
                )}

                <Text
                    size="xSmall"
                    $weight="regular"
                    color={isError ? 'error' : 'primary'}
                >
                    {message}
                </Text>
            </Container>
        )
    )
}
